<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>服务信息</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="服务名称" prop="servName">
                <el-input v-model="addHousekeepingServInfo.servName" placeholder="必填，请填写服务名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务类型" prop="hktId">
                <el-select v-model="addHousekeepingServInfo.hktId" placeholder="必填，请选择服务类型" style="width:100%">
                  <el-option v-for="(item,index) in addHousekeepingServInfo.housekeepingTypes" :key="index"
                    :label="item.hktName" :value="item.hktId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="关键词" prop="keyword">
                <el-input v-model="addHousekeepingServInfo.keyword" placeholder="必填，请填写关键词,多个关键词用;分隔"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回访方式" prop="returnVisitFlag">
                <el-select v-model="addHousekeepingServInfo.returnVisitFlag" placeholder="必填，请选择回访方式"
                  style="width:100%">
                  <el-option v-for="item in addHousekeepingServInfo.returnVisitFlags" :key="item.statusCd"
                    :label="item.name" :value="item.statusCd"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="销量" prop="sales">
                <el-input v-model="addHousekeepingServInfo.sales" placeholder="选填，请填写销量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="addHousekeepingServInfo.sort" placeholder="选填，请填写排序"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="上架状态" prop="state">
                <el-select v-model="addHousekeepingServInfo.state" placeholder="必填，请选择上架状态" style="width:100%">
                  <el-option v-for="item in addHousekeepingServInfo.states" :key="item.statusCd" :label="item.name"
                    :value="item.statusCd"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="派单方式" prop="repairWay">
                <el-select v-model="addHousekeepingServInfo.repairWay" placeholder="必填，请选择派单方式" style="width:100%">
                  <el-option v-for="item in addHousekeepingServInfo.repairWays" :key="item.statusCd" :label="item.name"
                    :value="item.statusCd"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="服务描述" prop="servDesc">
                <el-input type="textarea" v-model="addHousekeepingServInfo.servDesc"
                  placeholder="必填，请填写服务描述" :rows="3" maxlength="250"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>服务图片</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="服务封面">
                <upload-image-url 
                  ref="coverUpload" 
                  :image-count="1"
                  @notifyUploadCoverImage="handleCoverUploadSuccess">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="服务轮播">
                <upload-image-url 
                  ref="carouselUpload" 
                  :image-count="3"
                  @notifyUploadCoverImage="handleCarouselUploadSuccess">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>服务扩展</span>
      </div>
      <div class="">
        <el-form label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="服务详情">
                <RichTextEditor v-model="addHousekeepingServInfo.context" @input="handleContentChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="margin-top:20px;text-align:right;">
          <el-button type="warning" @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="saveHousekeepingServInfo">
            <i class="el-icon-check"></i>保存
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
import RichTextEditor from '@/components/system/RichTextEditor.vue'
import { saveHousekeepingServ } from '@/api/housekeeping/housekeepingServApi'
import { getHousekeepingTypes } from '@/api/housekeeping/housekeepingApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId ,getAreaCode} from '@/api/shop/shopApi'

export default {
  name: 'AddHousekeepingServ',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      addHousekeepingServInfo: {
        servId: '',
        servName: '',
        servDesc: '',
        hktId: '',
        sales: '',
        sort: '',
        state: '',
        states: [],
        repairWay: '',
        returnVisitFlag: '',
        keyword: '',
        coverPhoto: '',
        context: '',
        areaCode: '',
        carouselFigurePhoto: [],
        housekeepingTypes: [],
        repairWays: [],
        returnVisitFlags: []
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      await this._listAddHousekeepingTypes()
      await this.getDictData()
    },
    async getDictData() {
      try {
        const { data: repairWayData } = await getDict('housekeeping_serv', 'repair_way')
        this.addHousekeepingServInfo.repairWays = repairWayData

        const { data: stateData } = await getDict('housekeeping_serv', 'state')
        this.addHousekeepingServInfo.states = stateData

        const { data: returnVisitData } = await getDict('housekeeping_serv', 'return_visit_flag')
        this.addHousekeepingServInfo.returnVisitFlags = returnVisitData
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleCoverUploadSuccess(urls) {
      if (urls && urls.length > 0) {
        // 如果返回的是对象数组，取url属性；如果是字符串数组，直接使用
        this.addHousekeepingServInfo.coverPhoto = urls[0]
      } else {
        this.addHousekeepingServInfo.coverPhoto = ''
      }
    },
    handleCarouselUploadSuccess(urls) {
      if (urls && urls.length > 0) {
        // 如果返回的是对象数组，取url属性；如果是字符串数组，直接使用
        this.addHousekeepingServInfo.carouselFigurePhoto = urls
      } else {
        this.addHousekeepingServInfo.carouselFigurePhoto = []
      }
    },
    handleContentChange(content) {
      this.addHousekeepingServInfo.context = content
    },
    handleCancel() {
      this.$router.go(-1)
    },
    async _listAddHousekeepingTypes() {
      try {
        const res = await getHousekeepingTypes({
          page: 1,
          row: 50,
          typeCd: 1001,
          shopId: getShopId()
        })
        this.addHousekeepingServInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('获取服务类型失败:', error)
      }
    },
    async saveHousekeepingServInfo() {
      if (!this.validateForm()) {
        return
      }

      this.addHousekeepingServInfo.shopId = getShopId()
      this.addHousekeepingServInfo.areaCode = getAreaCode()

      try {
        const res = await saveHousekeepingServ(this.addHousekeepingServInfo)
        if (res.code === 0) {
          this.$message.success('添加成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg || '添加失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      }
    },
    validateForm() {
      if (!this.addHousekeepingServInfo.servName) {
        this.$message.error('服务名称不能为空')
        return false
      }
      
      if (this.addHousekeepingServInfo.servName.length > 128) {
        this.$message.error('服务名称不能超过128位')
        return false
      }
      
      if (!this.addHousekeepingServInfo.hktId) {
        this.$message.error('服务类型不能为空')
        return false
      }
      
      if (!this.addHousekeepingServInfo.keyword) {
        this.$message.error('关键词不能为空')
        return false
      }
      
      if (this.addHousekeepingServInfo.keyword.length > 256) {
        this.$message.error('关键词不能超过256位')
        return false
      }
      
      if (!this.addHousekeepingServInfo.returnVisitFlag) {
        this.$message.error('回访方式不能为空')
        return false
      }
      
      if (!this.addHousekeepingServInfo.state) {
        this.$message.error('上架状态不能为空')
        return false
      }
      
      if (!this.addHousekeepingServInfo.repairWay) {
        this.$message.error('派单方式不能为空')
        return false
      }
      
      if (!this.addHousekeepingServInfo.servDesc) {
        this.$message.error('服务描述不能为空')
        return false
      }
      
      if (this.addHousekeepingServInfo.servDesc.length > 256) {
        this.$message.error('服务描述不能超过256位')
        return false
      }
      
      if (!this.addHousekeepingServInfo.context) {
        this.$message.error('服务详情不能为空')
        return false
      }
      
      return true
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

/* 表单样式 */
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item:last-child {
}

/* 按钮样式 */
.el-button + .el-button {
  margin-left: 10px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .el-col {
    margin-bottom: 10px;
  }
}
</style>